/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import { del } from '../../helpers/api_helper';
import SupplierModal from '../../components/Sourcing/SupplierModal';

function Suppliers(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editModalSupplier, setEditModalSupplier] = useState({});
  const [signal, setSignal] = useState(0);

  const editSupplier = (entity) => {
    setEditModalSupplier(entity);
    setEditModalOpen(true);
  };

  const deleteSupplier = async (supplier, e) => {
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.blur();
    btn.firstChild.classList.toggle('bx-spin');

    // eslint-disable-next-line no-alert
    const cnfrm = confirm(props.t(`Are you sure you want to delete ${supplier.name}?`));

    if (cnfrm) {
      try {
        await del(`/api/sourcing/supplier/${supplier.id}`);

        toastr.success(`Deleted order ID: ${supplier.id}`, 'Success');
        setSignal(signal + 1);
      } catch (error) {
        toastr.error(error.message, 'Error');
      } finally {
        btn.disabled = false;
        btn.firstChild.classList.toggle('bx-spin');
      }
    }
  };

  const onEditSuccess = () => {
    setSignal(signal + 1);
  };

  const createEntity = () => {
    setEditModalSupplier({
      name: '',
      programs: [],
    });
    setEditModalOpen(true);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md="6">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Suppliers')}</CardTitle>

                <Can i="see" this="Suppliers">
                  <BaseGrid
                    url="/api/sourcing/supplier"
                    hasSearch
                    shouldUpdate={signal}
                    create={createEntity}
                    config={
                    {
                      columns: {
                        id: {
                          label: 'ID',
                          sort: true,
                          link: {
                            to: '/sourcing/supplier/%id%',
                          },
                        },
                        name: { label: 'Name', sort: true },
                        created_at: {
                          label: 'Created At',
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.LOCAL_TZ,
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'edit',
                              icon: 'bx bx-pencil',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: props.t('Edit'),
                              click: editSupplier,
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteSupplier,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 10,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Suppliers"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <SupplierModal shown={editModalOpen} entity={editModalSupplier} onSuccess={onEditSuccess} />
    </div>
  );
}

Suppliers.defaultProps = {
  t: (x) => (x),
};

Suppliers.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Suppliers));
